export default function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-collection/src/keys.js
// module id = ../../../../d3-collection/src/keys.js
// module chunks = 4